var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<modal modal-title=\"{{::$ctrl.title}}\" sub-title=\"{{::$ctrl.subTitle}}\" size=\"sm\" on-dismiss=\"$ctrl.$dismiss()\"><modal-body><customer-notes customer=\"$ctrl.customer\" locationmode=\"$ctrl.locationmode\"></customer-notes></modal-body><modal-footer><button type=\"button\" ng-click=\"$ctrl.$dismiss()\" ng-disabled=\"$ctrl.bus.activeCalls.length\" class=\"btn btn-default\">Cancel</button></modal-footer></modal>";
var id1="customer-notes-popup.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;